import React, { Component } from 'react';
import { observer, inject } from "mobx-react";
import { withRouter, NavLink } from "react-router-dom";
import RightPanelOptions from './RightPanelOptions';
let store = null;
var self = null;
@inject("appStore")
@observer
class Experience extends React.Component {

    constructor(props) {
        super(props);
    }


    render() {
        return (
            <section class="o-section  t-section  ">

                <div class="o-section__header-bg  t-section__header"></div>
                <div class="o-section__content-bg  t-section__content"></div>

                <div class="o-container">
                    <div class="o-section__container">

                        <header class="o-section__header  t-section__header">
                            <div class="o-content">
                                <h2 class="o-section__heading">
                                    Experience
                                </h2>
                                <div class="o-content__body  o-section__description">
                                    Over the years, my work has evolved from full-stack development to designing cloud-native, AI-powered platforms that combine governance, automation, and intelligent systems at enterprise scale.
                                </div>
                            </div>
                        </header>

                        <div class="o-section__content  t-section__content  u-pb-0">

                            <div class="a-experience-timeline  c-timeline  t-border-color">
                                <div class="c-timeline__item">
                                    <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                    <div class="o-content">
                                        <div class="o-grid">
                                            <div class="o-grid__col-md-5">
                                                <div class="c-work__timeframe">
                                                    2023 &ndash; Present
                                                </div>
                                                <h3 class="c-work__heading">
                                                    IT Expert – Cloud & Generative AI
                                                </h3>
                                                <h4 class="c-work__title">
                                                    Volkswagen Group Technology Pvt. Ltd. (VWITS), Pune, India
                                                </h4>
                                                <div class="c-work__location">
                                                    Mar 2023 – Present | Pune, India
                                                </div>
                                            </div>
                                            <div class="o-grid__col-md-7">
                                                <ul>
                                                    <li>
                                                        Architect and implement enterprise AWS Landing Zone solutions, including multi-account structures, AWS Organizations, and Service Control Policies (SCPs) to enforce governance, security, and compliance.
                                                    </li>
                                                    <li>
                                                        Lead the design and development of cloud automation platforms for AWS account provisioning, resource deployment, and governance using AWS CDK, Lambda, Step Functions, DynamoDB, S3, SQS, SNS and other serverless services with React JS and AWS CDK.
                                                    </li>
                                                    <li>
                                                       Build Generative AI and agentic AI systems using AWS Bedrock, enabling intelligent chatbots, automated root cause analysis, log interpretation, cost analysis, and security reviews.
                                                    </li>
                                                    <li>
                                                        Develop a React.js-based self-service portal hosted on AWS Amplify, allowing users to create AWS accounts and deploy cloud resources securely.
                                                    </li>
                                                    <li>
                                                        Collaborate with platform, security, and engineering teams to integrate GenAI solutions into enterprise workflows, improving operational efficiency and developer productivity.
                                                    </li>
                                                    <li>
                                                        Provide technical leadership on cloud architecture decisions, scalability, cost optimization, and secure AI adoption.
                                                    </li>
                                                </ul>
                                                <p>
                                                    Technologies: AWS (Lambda, CDK, Step Functions, DynamoDB, S3, Organizations, SCPs, Bedrock), React.js, Node.js, Python, LangChain, LangGraph
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="c-timeline__item">
                                    <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                    <div class="o-content">
                                        <div class="o-grid">
                                            <div class="o-grid__col-md-5">
                                                <div class="c-work__timeframe">
                                                    2021 &ndash; 2023
                                                </div>
                                                <h3 class="c-work__heading">
                                                    Consultant – AWS & AI Product Engineering
                                                </h3>
                                                <h4 class="c-work__title">
                                                    Capgemini
                                                </h4>
                                                <div class="c-work__location">
                                                    2021 – 2023 | Kolkata, India
                                                </div>
                                            </div>
                                            <div class="o-grid__col-md-7">
                                                <ul>
                                                    <li>
                                                        Designed and developed cloud-native products using AWS serverless services including Lambda, Step Functions, SQS, SNS, SES, DynamoDB, and S3.
                                                    </li>
                                                    <li>
                                                        Built backend services using Node.js and Python and developed React.js frontends for end-to-end product delivery.
                                                    </li>
                                                    <li>
                                                        Integrated NLP-based chatbots and intelligent automation into cloud applications to enhance user experience and business workflows.
                                                    </li>
                                                    <li>
                                                        Implemented Infrastructure as Code (IaC) using AWS CDK to automate provisioning and deployments.
                                                    </li>
                                                    <li>
                                                        Participated in architecture reviews, API design, and CI/CD pipelines to ensure scalability and reliability.
                                                    </li>
                                                </ul>
                                                <p>
                                                    Technologies: AWS, Node.js, Python, React.js, CDK, NLP, CI/CD
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="c-timeline__item">
                                    <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                    <div class="o-content">
                                        <div class="o-grid">
                                            <div class="o-grid__col-md-5">
                                                <div class="c-work__timeframe">
                                                    2020 &ndash; 2021
                                                </div>
                                                <h3 class="c-work__heading">
                                                    Senior Software Engineer – NLP & AI Systems
                                                </h3>
                                                <h4 class="c-work__title">
                                                    Chickpea India Software Pvt. Ltd.
                                                </h4>
                                                <div class="c-work__location">
                                                    2020 – 2021 | Kolkata, India
                                                </div>
                                            </div>
                                            <div class="o-grid__col-md-7">
                                                <ul>
                                                    <li>
                                                        Designed and implemented NLP and AI components for enterprise products, including text classification, summarization, information retrieval, and open-domain question answering.
                                                    </li>
                                                    <li>
                                                        Fine-tuned transformer models and LSTM-based architectures to improve accuracy and performance.
                                                    </li>
                                                    <li>
                                                        Built AI inference APIs using Python and Node.js and deployed them on Google Cloud Platform (GCP).
                                                    </li>
                                                    <li>
                                                        Collaborated with product and engineering teams to integrate AI components into production systems.
                                                    </li>
                                                </ul>
                                                <p>
                                                    Technologies: NLP, Transformers, Deep Learning, Python, Node.js, GCP
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="c-timeline__item">
                                    <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                    <div class="o-content">
                                        <div class="o-grid">
                                            <div class="o-grid__col-md-5">
                                                <div class="c-work__timeframe">
                                                    2019 &ndash; 2020
                                                </div>
                                                <h3 class="c-work__heading">
                                                   Senior Software Engineer – Conversational AI
                                                </h3>
                                                <h4 class="c-work__title">
                                                    Chickpea India Software Pvt. Ltd.
                                                </h4>
                                                <div class="c-work__location">
                                                    2019 – 2020 | Kolkata, India
                                                </div>
                                            </div>
                                            <div class="o-grid__col-md-7">
                                                <ul>
                                                    <li>
                                                        Built end-to-end contextual chatbot solutions using Dialogflow, integrated with AWS backend services.
                                                    </li>
                                                    <li>
                                                        Developed chatbot workflows connected to PostgreSQL, DynamoDB, and S3 for real-time data access.
                                                    </li>
                                                    <li>
                                                        Implemented real-time communication using WebSockets and Socket.io.
                                                    </li>
                                                    <li>
                                                        Developed React.js-based frontend applications for chatbot interfaces and operational dashboards.
                                                    </li>
                                                </ul>
                                                <p>
                                                    Technologies: Dialogflow, AWS, React.js, Node.js, WebSockets
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="c-timeline__item">
                                    <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                    <div class="o-content">
                                        <div class="o-grid">
                                            <div class="o-grid__col-md-5">
                                                <div class="c-work__timeframe">
                                                    2017 &ndash; 2019
                                                </div>
                                                <h3 class="c-work__heading">
                                                    Software Engineer – Full-Stack & Cloud Applications
                                                </h3>
                                                <h4 class="c-work__title">
                                                    Chickpea India Software Pvt. Ltd.
                                                </h4>
                                                <div class="c-work__location">
                                                    2017 – 2019 | Kolkata, India
                                                </div>
                                            </div>
                                            <div class="o-grid__col-md-7">
                                                {/* <p>
                                                    To develop and maintain various applications for Hexaride Technologies Pvt. Ltd. as mentioned below :
                                                    <br></br>
                                                    <br></br>
                                                    &#10003; Customer facing Android apps in Android Studio using JAVA.
                                                    <br></br>
                                                    &#10003; Web portal to manage entire Operations in React JS, APIs in Node Js and Python.
                                                    <br></br>
                                                    &#10003; Project Route Analysis - S3 + ELK Stack + Node JS
                                                    <br></br>
                                                    &#10003; Databases used : Postgresql, DynamoDb, MongoDb, Firebase.
                                                    <br></br>
                                                    &#10003; Storage used : GCP Bucket, AWS S3.
                                                    <br></br>
                                                    &#10003; APIs : Build with Python and Node Js.
                                                    <br></br>
                                                    &#10003; Authentication + Authorizer : AWS Cognito
                                                </p> */}
                                                <ul>
                                                    <li>
                                                        Developed and maintained full-stack applications using React.js, Node.js, and Python.
                                                    </li>
                                                     <li>
                                                        Built Android applications using Java for customer-facing platforms.
                                                    </li>
                                                     <li>
                                                        Implemented log analytics and data pipelines using AWS S3 and ELK Stack.
                                                    </li>
                                                     <li>
                                                        Worked with multiple databases including PostgreSQL, DynamoDB, MongoDB, and Firebase.
                                                    </li>
                                                     <li>
                                                        Implemented authentication and authorization using AWS Cognito.
                                                    </li>
                                                </ul>
                                                <p>
                                                    Technologies: React.js, Node.js, Python, AWS, Databases, Cognito
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>

            </section>
        );
    }
}

export default withRouter(Experience);